import { render, staticRenderFns } from "./assessment-view.vue?vue&type=template&id=229fb589&scoped=true&"
import script from "./assessment-view.vue?vue&type=script&lang=js&"
export * from "./assessment-view.vue?vue&type=script&lang=js&"
import style0 from "./assessment-view.vue?vue&type=style&index=0&id=229fb589&lang=scss&scoped=true&"
import style1 from "./assessment-view.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./assessment-view.vue?vue&type=style&index=2&id=229fb589&scoped=true&lang=css&"
import style3 from "./assessment-view.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229fb589",
  null
  
)

export default component.exports